import { env } from '../env.mjs';
import { isClient } from './is-client';
import { isSSR } from './is-ssr';

type EnvKeys = keyof typeof env;

type StripPrefix<T extends string> = T extends `NEXT_PUBLIC_${infer U}` ? U : T;

export function getEnv<K extends EnvKeys>(key: StripPrefix<K>) {
  if (isClient()) {
    const prefixedKey = `NEXT_PUBLIC_${key}` as keyof typeof env;
    return env[prefixedKey] as (typeof env)[K];
  }

  if (isSSR()) {
    return env[key as keyof typeof env] as (typeof env)[K];
  }

  throw new Error('Environment not available.');
}

export function checkEnv<K extends EnvKeys>(key: StripPrefix<K>, valueToValid: unknown) {
  const envValue = getEnv(key);

  return envValue === valueToValid;
}
